export var localStorage = typeof window === "undefined" ? null : window.localStorage;
//# sourceMappingURL=localStorage.js.map